<template>
  <div class="page-template" v-loading="loading">
    <!--    <div class="page-title">{{ title }}</div>-->
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="收银日报" name="cashierDayStatement">
        <search-form-template
          :searchOptions="cashierDayStatementSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcelCashierDay()"
        ></search-form-template>
        <table-template ref="cashierDayStatement" :tableOptions="cashierDayStatementTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="收银员对账" name="cashierReconciliation">
        <search-form-template
          :searchOptions="cashierReconciliationSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcelCashierReconciliation()"
        ></search-form-template>
        <table-template ref="cashierReconciliation" :tableOptions="cashierReconciliationTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="自定义支付" name="customPay">
        <search-form-template
          :searchOptions="customPaySearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcelCustomPay()"
        ></search-form-template>
        <table-template ref="customPay" :tableOptions="customPayTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="收银员日报(日期)" name="cashierDateStatement">
        <search-form-template
          :searchOptions="cashierDateStatementSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcelCashierDate()"
        ></search-form-template>
        <table-template ref="cashierDateStatement" :tableOptions="cashierDateStatementTable"></table-template>
      </el-tab-pane>
      <el-tab-pane label="门店收银日报" name="storeCashier">
        <search-form-template
          :searchOptions="storeCashierSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcelStoreCashier()"
        ></search-form-template>
        <table-template ref="storeCashier" :tableOptions="storeCashierTable"></table-template>
      </el-tab-pane>
      <!--      <el-tab-pane label="储值卡充值" name="petCardCredit">-->
      <!--        <search-form-template-->
      <!--          :searchOptions="petCardCreditSearchOptions"-->
      <!--          @searchSubmit="searchSubmit"-->
      <!--          @clear="clearSearch"-->
      <!--          :toolConfig="toolConfig"-->
      <!--        ></search-form-template>-->
      <!--        <table-template ref="petCardCredit"-->
      <!--                        :tableOptions="petCardCreditTable">-->
      <!--        </table-template>-->
      <!--      </el-tab-pane>-->
      <!--      <el-tab-pane label="项目次数充值" name="projectCredit">-->
      <!--        <search-form-template-->
      <!--          :searchOptions="projectCreditSearchOptions"-->
      <!--          @searchSubmit="searchSubmit"-->
      <!--          @clear="clearSearch"-->
      <!--          :toolConfig="toolConfig"-->
      <!--        >-->
      <!--        </search-form-template>-->
      <!--        <table-template ref="projectCredit"-->
      <!--                        :tableOptions="projectCreditTable">-->
      <!--        </table-template>-->
      <!--      </el-tab-pane>-->
      <el-dialog
        title="组合支付详情"
        :visible.sync="listShow"
        width="1000px"
        height="2000px"
        :close-on-click-modal="false"
      >
        <list-template :tableOptions="cashierDayStatementListColumns" :tableData="sumTableData"
                       ref="listOperation"></list-template>
      </el-dialog>
      <el-dialog
        title="退款详情"
        :visible.sync="refundListShow"
        width="1000px"
        height="2000px"
        :close-on-click-modal="false"
      >
        <list-template :tableOptions="cashierDayRefundListColumns" :tableData="refundTableData"
                       ref="listOperation"></list-template>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
import searchFormTemplate from '@/components/template/searchFormTemplate';
import tableTemplate from '@/components/template/tableTemplate';
import api from '@/config/api';
import userPower from '@/mixin/userPower'
import listTemplate from '@/components/template/listTemplate';

export default {
  mixins: [userPower],
  name: 'RoleManager',
  components: {
    tableTemplate,
    searchFormTemplate,
    listTemplate
  },
  data() {
    return {
      nowDateStart: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      nowDateEnd: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      activeTab: 'cashierDayStatement',
      listShow: false,
      refundListShow: false,
      loading: false,
      treeConfig: {
        id: 'menuTree',
        showCheckbox: true,
        data: [],
        nodeKey: 'id',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        request: {
          api: api.system.rolePrivilege,
          param: {roleId: ''}
        }
      },

      // 更多功能
      toolConfig: [
        {
          label: '打印',
          code: 'print'
        },
        {
          label: '导出',
          code: 'export',
          callback: this.exportExcel
        }
      ],

      // 收银日报
      cashierDayStatementSearchOptions: {
        simple: [{
          label: '',
          type: 'input',
          prop: 'cashierSttName',
          isFuzzy: true,
          placeholder: '请输入门店名称/收银员姓名'
        },],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            data: [],
            isHasAll: true,
            span: 12,
            width: "150",
            change: this.getDayCashier,
            url: api.system.seStore
          },
          // {
          //   label: '业务类型',
          //   type: 'select',
          //   prop: 'orderType',
          //   data: this.$utils.getCacheStatus('soBillOrder.orderType'),
          //   span: 8,
          //   width: "150",
          // },
          {
            label: '收银员',
            type: 'select',
            prop: 'cashierId',
            data: [],
            span: 12,
            // url: api.system.account,
            // param:{type:40}
          },
          // {
          //   label: '方式',
          //   prop: 'zeroType',
          //   type: 'radio',
          //   span: 12,
          //   data: [{label: '包含抹零金额', value: 20}],
          // },
        ]
      },
      // //收银员对账
      cashierReconciliationSearchOptions: {
        simple: [{
          label: '',
          type: 'input',
          prop: 'cashierReltName',
          isFuzzy: true,
          placeholder: '请输入门店名称/收银员姓名'
        },],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            data: [],
            span: 8,
            isHasAll: true,
            width: "150",
            change: this.getReconciliationCashier,
            url: api.system.seStore
          },
          {
            label: '交易类型',
            type: 'select',
            prop: 'orderType',
            data: this.$utils.getCacheStatus('soBillOrder.orderType'),
            span: 8,
            width: "150",
          },
          {
            label: '收银员',
            type: 'select',
            prop: 'cashierId',
            data: [],
            span: 8,
            // url: api.system.account,
            // param:{type:40}
          },
          {
            label: '方式',
            prop: 'zeroType',
            type: 'radio',
            span: 8,
            data: [{label: '包含抹零金额', value: 20}],
          },
          {
            label: '交易方式',
            prop: 'orderType',
            type: 'radio',
            span: 8,
            data: this.$utils.getCacheStatus('soBillOrder.orderType')
          },
        ]
      },
      // 自定义支付
      customPaySearchOptions: {
        simple: [{
          label: '',
          type: 'input',
          prop: 'customPayName',
          isFuzzy: true,
          placeholder: '请输入门店名称/收银员姓名'
        },],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            data: [],
            span: 8,
            isHasAll: true,
            width: "150",
            change: this.getPayCashier,
            url: api.system.seStore
          },
          // {
          //   label: '交易类型',
          //   type: 'select',
          //   prop: 'orderType',
          //   data: this.$utils.getCacheStatus('soBillOrder.orderType'),
          //   span: 8,
          //   width: "150",
          // },
          {
            label: '收银员',
            type: 'select',
            prop: 'cashierId',
            data: [],
            span: 8,
            // url: api.system.account,
            // param:{type:40}
          },
          {
            label: '支付方式',
            type: 'select',
            prop: 'otherPayId',
            span: 8,
            data: []
            // data: this.$utils.getCacheStatus('soBillOrder.payType')
          },
          {
            label: '方式',
            prop: 'zeroType',
            type: 'radio',
            span: 8,
            data: [{label: '包含抹零金额', value: 20}],
          },
        ]
      },
      // 收银日报（日期）
      cashierDateStatementSearchOptions: {
        simple: [{
          label: '',
          type: 'input',
          prop: 'cashierDateName',
          isFuzzy: true,
          placeholder: '请输入门店名称/收银员姓名'
        },],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            data: [],
            isHasAll: true,
            span: 8,
            width: "200",
            change: this.getCashierDate,
            url: api.system.seStore
          },
          // {
          //   label: '交易类型',
          //   type: 'select',
          //   prop: 'orderType',
          //   data: this.$utils.getCacheStatus('soBillOrder.orderType'),
          //   span: 8,
          //   width: "150",
          // },
          {
            label: '收银员',
            type: 'select',
            prop: 'cashierId',
            data: [],
            span: 8,
            // url: api.system.account,
            // param:{type:40}
          },
          // {
          //   label: '方式',
          //   prop: 'zeroType',
          //   type: 'radio',
          //   span: 12,
          //   data: [{label: '包含抹零金额', value: 20}],
          // },
        ]
      },
      // 门店收银日报
      storeCashierSearchOptions: {
        simple: [{
          label: '',
          type: 'input',
          prop: 'storeName',
          isFuzzy: true,
          placeholder: '请输入门店名称'
        },],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
          {
            label: '门店名称',
            type: 'select',
            prop: 'storeId',
            data: [],
            isHasAll: true,
            span: 12,
            width: "150",
            change: this.getCashierStore,
            url: api.system.seStore
          },
          // {
          //   label: '交易类型',
          //   type: 'select',
          //   prop: 'orderType',
          //   data: this.$utils.getCacheStatus('soBillOrder.orderType'),
          //   span: 12,
          //   width: "150",
          // },
          // {
          //   label: '方式',
          //   prop: 'zeroType',
          //   type: 'radio',
          //   span: 12,
          //   data: [{label: '包含抹零金额', value: 20}],
          // },
        ]
      },

      //收银日报
      cashierDayStatementTable: {
        showSummary: true,
        summaryColumns: ['cashierMoney', 'dbyMoney', 'bankCardMoney', 'weChatMoney', 'aliMoney', 'vipMoney'
          , 'programMoney', 'otherMoney', 'combinationMoney', 'malingAmount', 'refundPrice', 'totalMoney'],
        indexShow: true,//是否显示索引
        param: {
          zeroType: 10,
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        }, // 不包含抹零
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '门店名称',
            prop: 'storeName',
            align: 'center',
            width: "150",
          },
          // {
          //   label: '门店编码',
          //   prop: 'storeCode',
          //   width: '100',
          //   align: 'center',
          // },
          // {
          //   label: '收银员ID',
          //   prop: 'cashierId',
          //   width: '100',
          //   align: 'center'
          // },
          {
            label: '收银员姓名',
            prop: 'cashierName',
            width: '100',
            align: 'center'
          },
          {
            label: '收银员编码',
            prop: 'cashierCode',
            width: '100',
            align: 'center'
          },
          {
            label: '合计(不含找零)',
            prop: 'totalMoney',
            width: '150',
            align: 'center'
          },
          {
            label: '现金',
            prop: 'cashierMoney',
            width: '100',
            align: 'center',
          },
          {
            label: '店播',
            prop: 'dbyMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '银行卡',
            prop: 'bankCardMoney',
            width: '100',
            align: 'center',
          },
          {
            label: '微信',
            prop: 'weChatMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '支付宝',
            prop: 'aliMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '会员',
            prop: 'vipMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '小程序',
            prop: 'programMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '其他支付',
            prop: 'otherMoney',
            width: '100',
            align: 'center'
          },
          // {
          //   label: '组合支付(已统计)',
          //   prop: 'combinationMoney',
          //   width: '150',
          //   align: 'center',
          //   // showDetailBox: true,
          //   // code: 'showDetailBox',
          //   callback: this.showDetailBox,
          // },
          // {
          //   label: '抹零金额',
          //   prop: 'malingAmount',
          //   width: '150',
          //   align: 'center'
          // },
          // {
          //   label: '退款金额',
          //   prop: 'refundPrice',
          //   width: '150',
          //   align: 'center',
          //   callback: this.showRefundDetail,
          // },
        ],
        url: api.retail.cashierDayStatement
      },
      sumTableData: [],
      //弹出框表格字段
      cashierDayStatementListColumns: {
        disabled: false,
        indexShow: true, //是否显示索引
        showSummary: true,
        summaryColumns: ['payPrice'],
        columns: [
          {
            label: '订单号',
            prop: 'orderNo',
            width: '300',
            align: 'center'
          },
          {
            label: '支付方式',
            prop: 'payType',
            width: '150',
            enumData: this.$utils.getCacheStatus("soBillOrder.payType")
          },
          {
            label: '支付金额',
            prop: 'payPrice',
            width: '100',
          },
          {
            label: '支付时间',
            prop: 'createDttm',
            width: '200',
            align: 'center'
          },
        ],
      },
      refundTableData: [],
      //退款弹出框表格字段
      cashierDayRefundListColumns: {
        disabled: false,
        indexShow: true, //是否显示索引
        showSummary: true,
        summaryColumns: ['payPrice'],
        columns: [
          {
            label: '支付单号',
            prop: 'refundNo',
            width: '200',
            align: 'center'
          },
          {
            label: '退款单号',
            prop: 'orderNo',
            width: '200',
            align: 'center'
          },
          {
            label: '退款方式',
            prop: 'payType',
            width: '150',
            enumData: this.$utils.getCacheStatus("soBillOrder.payType")
          },
          // {
          //   label: '退款金额',
          //   prop: 'payPrice',
          //   width: '100',
          // },
          {
            label: '退款时间',
            prop: 'createDttm',
            width: '200',
            align: 'center'
          },
        ],
      },
      //收银对账
      cashierReconciliationTable: {
        showSummary: true,
        summaryColumns: ['amountReceived'],
        indexShow: true,//是否显示索引
        param: {
          zeroType: 10,
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        }, // 不包含抹零
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '门店名称',
            prop: 'storeName',
            align: 'center',
            width: "150",
          },
          // {
          //   label: '门店编码',
          //   prop: 'storeCode',
          //   width: '100',
          //   align: 'center'
          // },
          {
            label: '收银员编码',
            prop: 'cashierCode',
            width: '100',
            align: 'center'
          },
          {
            label: '收银员姓名',
            prop: 'cashierName',
            width: '100',
            align: 'center'
          },
          {
            label: '交易类型',
            prop: 'orderType',
            width: '150',
            align: 'center',
            enumData: this.$utils.getCacheStatus('soBillOrder.orderType')
          },
          {
            label: '金额',
            prop: 'amountReceived',
            width: '150',
            align: 'center'
          }
        ],
        url: api.retail.cashierReconciliation
      },
      //自定义支付
      customPayTable: {
        showSummary: true,
        summaryColumns: ['amountReceived'],
        param: {
          zeroType: 10,
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        }, // 不包含抹零
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '门店名称',
            prop: 'storeName',
            align: 'center',
            width: "150",
          },
          // {
          //   label: '门店编码',
          //   prop: 'storeCode',
          //   width: '100',
          //   align: 'center'
          // },
          {
            label: '收银员编码',
            prop: 'cashierCode',
            width: '100',
            align: 'center'
          },
          {
            label: '收银员姓名',
            prop: 'cashierName',
            width: '100',
            align: 'center'
          },
          {
            label: '销售日期',
            prop: 'dayDate',
            width: '150',
            align: 'center'
          },
          // {
          //   label: '交易类型',
          //   prop: 'orderType',
          //   width: '150',
          //   align: 'center',
          //   enumData: this.$utils.getCacheStatus('soBillOrder.orderType')
          // },
          {
            label: '支付方式',
            prop: 'payModeName',
            width: '150',
            align: 'center',
          },
          {
            label: '金额',
            prop: 'amountReceived',
            width: '150',
            align: 'center'
          }
        ],
        url: api.retail.customPay
      },
      // 收银日报（日期）
      cashierDateStatementTable: {
        showSummary: true,
        summaryColumns: ['cashierMoney', 'dbyMoney', 'bankCardMoney', 'weChatMoney', 'aliMoney', 'vipMoney'
          , 'programMoney', 'otherMoney', 'combinationMoney', 'malingAmount', 'totalMoney'],
        indexShow: true,//是否显示索引
        param: {
          zeroType: 10,
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        }, // 不包含抹零
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '门店名称',
            prop: 'storeName',
            align: 'center',
            width: "150",
          },
          // {
          //   label: '门店编码',
          //   prop: 'storeCode',
          //   width: '100',
          //   align: 'center',
          // },
          {
            label: '收银员编码',
            prop: 'cashierCode',
            width: '100',
            align: 'center'
          },
          {
            label: '收银员姓名',
            prop: 'cashierName',
            width: '100',
            align: 'center'
          },
          {
            label: '销售日期',
            prop: 'dayDate',
            width: '150',
            align: 'center'
          },
          {
            label: '合计(不含找零)',
            prop: 'totalMoney',
            width: '150',
            align: 'center'
          },
          {
            label: '现金',
            prop: 'cashierMoney',
            width: '100',
            align: 'center',
          },
          {
            label: '店播',
            prop: 'dbyMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '银行卡',
            prop: 'bankCardMoney',
            width: '100',
            align: 'center',
          },
          {
            label: '微信',
            prop: 'weChatMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '支付宝',
            prop: 'aliMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '会员',
            prop: 'vipMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '小程序',
            prop: 'programMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '其他支付',
            prop: 'otherMoney',
            width: '100',
            align: 'center'
          },
          // {
          //   label: '组合支付(已统计)',
          //   prop: 'combinationMoney',
          //   width: '150',
          //   align: 'center',
          //   // showDetailBox: true,
          //   // code: 'showDetailBox',
          //   callback: this.showDetailBox,
          // },
          // {
          //   label: '抹零金额',
          //   prop: 'malingAmount',
          //   width: '150',
          //   align: 'center'
          // },
          // {
          //   label: '退款金额',
          //   prop: 'refundPrice',
          //   width: '150',
          //   align: 'center',
          //   callback: this.showRefundDetail,
          // },
        ],
        url: api.retail.cashierDateStatement
      },
      // 门店收银员日报
      storeCashierTable: {
        showSummary: true,
        summaryColumns: ['cashierMoney', 'dbyMoney', 'bankCardMoney', 'weChatMoney', 'aliMoney', 'vipMoney'
          , 'programMoney', 'otherMoney', 'combinationMoney', 'malingAmount', 'totalMoney'],
        param: {
          zeroType: 10,
          edCreateDttm: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          stCreateDttm: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        }, // 不包含抹零
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '门店名称',
            prop: 'storeName',
            align: 'center',
            width: "150",
          },
          // {
          //   label: '门店编码',
          //   prop: 'storeCode',
          //   width: '100',
          //   align: 'center',
          // },
          {
            label: '销售日期',
            prop: 'dayDate',
            width: '120',
            align: 'center',
          },
          {
            label: '合计(不含找零)',
            prop: 'totalMoney',
            width: '150',
            align: 'center'
          },
          {
            label: '现金',
            prop: 'cashierMoney',
            width: '100',
            align: 'center',
          },
          {
            label: '店播',
            prop: 'dbyMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '银行卡',
            prop: 'bankCardMoney',
            width: '100',
            align: 'center',
          },
          {
            label: '微信',
            prop: 'weChatMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '支付宝',
            prop: 'aliMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '会员',
            prop: 'vipMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '小程序',
            prop: 'programMoney',
            width: '100',
            align: 'center'
          },
          {
            label: '其他支付',
            prop: 'otherMoney',
            width: '100',
            align: 'center'
          },
          // {
          //   label: '组合支付(已统计)',
          //   prop: 'combinationMoney',
          //   width: '150',
          //   align: 'center',
          //   callback: this.showDetailBox,
          // },
          // {
          //   label: '抹零金额',
          //   prop: 'malingAmount',
          //   width: '150',
          //   align: 'center'
          // },
          // {
          //   label: '退款金额',
          //   prop: 'refundPrice',
          //   width: '150',
          //   align: 'center',
          //   callback: this.showRefundDetail,
          // },
        ],
        url: api.retail.storeCashier
      },
    };
  },
  created() {
    this.title = document.title;
    this.setStore(this.cashierDayStatementSearchOptions.complex);
    this.setStore(this.cashierReconciliationSearchOptions.complex);
    this.setStore(this.customPaySearchOptions.complex);
    this.setStore(this.cashierDateStatementSearchOptions.complex);
    this.setStore(this.storeCashierSearchOptions.complex);
    // this.setStore(this.petCardCreditSearchOptions.complex);
    // this.getCashier();
    let userInfo = this.$utils.getSysUser();
    if (userInfo.storeId) {
      this.getCashier(userInfo.storeId)
    }
  },
  mounted() {
  },
  methods: {
    getStoreList() {
      this.$axios.fetchPost(api.system.seStore + '/list', {}).then(data => {
        if (data.code === 200) {
          this.cashierDayStatementSearchOptions.complex.filter(item => item.prop === 'storeId')[0].data = []
          this.cashierReconciliationSearchOptions.complex.filter(item => item.prop === 'storeId')[0].data = []
          this.customPaySearchOptions.complex.filter(item => item.prop === 'storeId')[0].data = []
          this.cashierDateStatementSearchOptions.complex.filter(item => item.prop === 'storeId')[0].data = []
          this.storeCashierSearchOptions.complex.filter(item => item.prop === 'storeId')[0].data = []
        }
      });
    },
    tabChange() {
      this.$refs[this.activeTab].operationSuccess();
    },
    searchSubmit(param) {
      this.$refs[this.activeTab].searchParam = param;
      this.$refs[this.activeTab].operationSuccess();
    },
    clearSearch() {
      this.$refs[this.activeTab].clearSearch();
      // this.$refs['cashierDayStatement'].clearSearch();
      // this.$refs['cashierReconciliation'].clearSearch();
      // this.$refs['customPay'].clearSearch();
      // this.$refs['cashierDateStatement'].clearSearch();
      // this.$refs['storeCashier'].clearSearch();
      let userInfo = this.$utils.getSysUser();
      if (!userInfo.storeId) {
        this.cashierDayStatementSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = []
        this.cashierReconciliationSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = []
        this.customPaySearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = []
        this.cashierDateStatementSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = []
        // this.storeCashierSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = []
      }
    },
    getCashier(storeId) {
      this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: storeId}).then(data => {
        if (data.code === 200) {
          this.cashierDayStatementSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          this.cashierReconciliationSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          this.customPaySearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          this.cashierDateStatementSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          // this.storeCashierSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
        }
      });
    },
    getDayCashier(form) {
      form.cashierId = '';
      this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.cashierDayStatementSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
        }
      });
    },
    getReconciliationCashier(form) {
      form.cashierId = '';
      this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.cashierReconciliationSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
        }
      });
    },
    getPayCashier(form) {
      form.cashierId = '';
      this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.customPaySearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
        }
      });
      this.$axios.fetchPost(api.system.sysPayMode, {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.customPaySearchOptions.complex.filter(item => item.prop === 'otherPayId')[0].data = data.data;
        }
      });
    },
    getCashierDate(form) {
      form.cashierId = '';
      this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.cashierDateStatementSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
        }
      });
    },
    getCashierStore(form) {
      // form.cashierId = '';
      // this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: form.storeId}).then(data => {
      //   if (data.code === 200) {
      //     this.storeCashierSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
      //   }
      // });
    },
    // getCardChange(form) {
    //   form.cashierId = '';
    //   this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: form.storeId}).then(data => {
    //     if (data.code === 200) {
    //       this.petCardCreditSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
    //     }
    //   });
    // },
    // getProjectChange(form) {
    //   form.cashierId = '';
    //   this.$axios.fetchPost(api.system.staffPage + '/list', {storeId: form.storeId}).then(data => {
    //     if (data.code === 200) {
    //       this.projectCreditSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
    //     }
    //   });
    // },

    // 收银日报
    exportExcelCashierDay() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = this.$refs["cashierDayStatement"].searchParam;
      param.zeroType = 10;
      this.$axios.PostBlob(api.retail.cashierDayStatementExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '收银日报_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
    // 收银员对账
    exportExcelCashierReconciliation() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = this.$refs["cashierReconciliation"].searchParam;
      param.zeroType = 10;
      this.$axios.PostBlob(api.retail.cashierReconciliationExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '收银员对账_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
    // 自定义支付
    exportExcelCustomPay() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = this.$refs["customPay"].searchParam;
      param.zeroType = 10;
      this.$axios.PostBlob(api.retail.customPayExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '自定义支付_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
    // 收银员日报(日期)
    exportExcelCashierDate() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = this.$refs["cashierDateStatement"].searchParam;
      param.zeroType = 10;
      this.$axios.PostBlob(api.retail.cashierDateStatementExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '收银员日报(日期)_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
    // 门店收银日报
    exportExcelStoreCashier() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = this.$refs["storeCashier"].searchParam;
      param.zeroType = 10;
      this.$axios.PostBlob(api.retail.storeCashierExport, param).then(res => {
        if (res.status === 200) {
          const fileName = '门店收银日报_' + this.$utils.getDateTime() + ".xlsx";
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error("导出失败,请稍后再试");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      });
    },
    showDetailBox(data) {
      let params = this.$refs['cashierDayStatement'].searchParam;
      params.storeId = data.storeId;
      params.cashierId = data.cashierId;
      params.dayDate = data.dayDate;
      if (params.dayDate) {
        params.stCreateDttm = null;
        params.edCreateDttm = null;
      }
      this.loading = true;
      this.$axios
        .fetchPost(api.retail.pombinationPayDetail, params)
        .then((data) => {
          this.loading = false;
          if (data.code === 200) {
            this.listShow = true;
            this.sumTableData = data.data;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$message({message: '请求失败！', type: 'error'});
        });
    },
    showRefundDetail(data) {
      let params = this.$refs['cashierDayStatement'].searchParam;
      params.storeId = data.storeId;
      params.cashierId = data.cashierId;
      params.dayDate = data.dayDate;
      if (params.dayDate) {
        params.stCreateDttm = null;
        params.edCreateDttm = null;
      }
      this.loading = true;
      this.$axios
        .fetchPost(api.retail.refundDetail, params)
        .then((data) => {
          this.loading = false;
          if (data.code === 200) {
            this.refundListShow = true;
            this.refundTableData = data.data;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$message({message: '请求失败！', type: 'error'});
        });
    }
  }
}
</script>

<style scoped>
.page-template {
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/page/retail/query/cashier/Reconciliation.vue